export default __webpack_public_path__ + "static/media/pin-booked.f9e97a5a.svg";